export const LOAD_PROPOSALS = 'PROPOSALS/LOAD_PROPOSALS';
export const LOAD_PROPOSALS_SUCCESS = 'PROPOSALS/LOAD_PROPOSALS_SUCCESS';
export const LOAD_PROPOSALS_ERROR = 'PROPOSALS/LOAD_PROPOSALS_ERROR';

export const UPDATE_PROPOSAL_STATE = 'PROPOSALS/UPDATE_PROPOSAL_STATE';
export const CLEAR_PROPOSAL_STATE = 'PROPOSALS/CLEAR_PROPOSAL_STATE';
export const CLOSE_ORDERS = 'PROPOSALS/CLOSE_ORDERS';
export const CLOSE_ORDERS_SUCCESS = 'PROPOSALS/CLOSE_ORDERS_SUCCESS';
export const CLOSE_ORDERS_ERROR = 'PROPOSALS/CLOSE_ORDERS_ERROR';

export const CANCEL_PROPOSAL = 'PROPOSALS/CANCEL_PROPOSAL';
export const CANCEL_PROPOSAL_SUCCESS = 'PROPOSALS/CANCEL_PROPOSAL_SUCCESS';
export const CANCEL_PROPOSAL_ERROR = 'PROPOSALS/CANCEL_PROPOSAL_ERROR';

export const CANCEL_NEW_OPERATIONS_PROPOSAL = 'PROPOSAL/CANCEL_NEW_OPERATIONS_PROPOSAL';
export const CANCEL_NEW_OPERATIONS_PROPOSAL_SUCCESS = 'PROPOSAL/CANCEL_NEW_OPERATIONS_PROPOSAL_SUCCESS';
export const CANCEL_NEW_OPERATIONS_PROPOSAL_ERROR = 'PROPOSAL/CANCEL_NEW_OPERATIONS_PROPOSAL_ERROR';
